const data = {
  fastcompany: {
    logo:
      '//a.fastcompany.net/image/upload/v1488299125/fc/fastcompany-logo.svg',
    title: 'Fast Company',
    subscribeLink: 'https://www.fastcompany.com/combo',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [
      {
        url: '/section/coronavirus',
        title: 'COVID-19',
        eyebrow: 'UPDATES'
      },
      {
        url: '/co-design',
        title: 'Co.Design'
      },
      {
        url: '/technology',
        title: 'Tech'
      },
      {
        url: '/work-life',
        title: 'Work Life'
      },
      {
        url: '/news',
        title: 'News'
      },
      {
        url: '/impact',
        title: 'Impact'
      },
      {
        url: '/podcasts',
        title: 'Podcasts',
        removeOnScale: true,
        external: true
      },
      {
        url: '/videos',
        title: 'Video'
      },
      {
        url: '/recommender',
        title: 'Recommender'
      },
      {
        url: 'https://magazine.fastcompany.com/loc/FST/sidenav1999',
        title: 'Subscribe',
        external: true,
        // removeOnScale: true,
        bold: true,
        subtopics: [
          {
            title: 'Newsletters',
            url: '/newsletters'
          },
          {
            title: 'Magazine',
            external: true,
            url: 'https://magazine.fastcompany.com/loc/FST/topnav1'
          }
        ]
      }
    ],
    channels: [
      {
        logo: '',
        title: 'FastCo Works',
        items: [
          {
            url: '/fcw/mckinsey__company',
            title: 'McKinsey & Company'
          },
          {
            url: '/fcw/principal_financial_group',
            title: 'Principal Financial Group'
          }
        ]
      }
    ]
  }
};

export default data;
